export const categoryLabels = {
  digitalLciMobileApp: 'Digital LCI - Mobile App Inventory',
  digitalLciMobileWeb: 'Digital LCI - Mobile Web/Desktop Inventory',
  digitalLciConnectedTv: 'Digital LCI - Connected TV/OTT Inventory',
  tvLciLinear: 'TV LCI - Linear TV',
  tvLciAddressable: 'TV LCI - Addressable TV',
  websiteLci: 'Website LCI',
  oohLci: 'OOH LCI',
  directMail: 'Direct Mail/Print LCI',
} as const satisfies Record<string, string>;
